import { Injectable } from "@angular/core";

@Injectable()
export class mailInfo {
    public username: string;
    public message: string;
    public mobileNumber: string;
    public subject: string;
    public messageHead: string;
    public error: boolean;
    public errorMessage: string;
    public fromAddress: string;
    public toAddress: string;
    public ccAddress: string;
    public company: string;
    public state: string;
    public postalCode: string;
    public country: string;
    public language: string;
    public address: string;
    public userMessage: string;
    public paymentMethodForTechnical?: string;
    public isSchool: boolean;
    public accountId: number;
    public personalDataAccess: boolean;
    public professional: boolean;
    public trueInformation: boolean;
    public termsConditions: boolean;
    public agrement: string;
    public siren: number;
    public siret: string;
    public isVHUICPE: boolean;
}